<template>
  <div>
    <div v-if="editMode">
      <Color title="Cor" v-model="selectedColor" />
      <div class="text-center">
        <Button
          _key="saveStepColor"
          type="success"
          title="Salvar"
          classIcon="fa-solid fa-floppy-disk"
          size="small"
          :clicked="save"
        />
      </div>
    </div>
    <div
      v-else
      class="step-color-picker-dot"
      :style="{ backgroundColor: color }"
    ></div>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import Color from "@/ui/forms/Color";

import StepService from "../../services/step.service";

import { mapMutations } from "vuex";

export default {
  name: "StepColorPicker",
  components: { Color, Button },
  props: {
    id: String,
    color: String,
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedColor: this.color,
    };
  },
  methods: {
    ...mapMutations("generic", ["hideModal", "addEvent", "removeLoading"]),
    async save() {
      try {
        await StepService.updateColor(this.id, this.selectedColor);
        this.hideModal();
        this.addEvent({ name: "colorStepUpdated" });
      } finally {
        this.removeLoading(["saveStepColor"]);
      }
    },
  },
};
</script>

<style scoped>
.step-color-picker-dot {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  display: inline-block;
}
</style>

